import React from "react";
import AppButton from "@common/components/app-button";
import {ReactComponent as AddDocumentIcon} from "@assets/icons/add-document.svg";
import {classNames} from "@utils/class-names";

interface FilePickerActionsProps {
    hasFiles: boolean;
    disabled: boolean;
    canAddMore: boolean;
    onPick: () => void;
    onClearAll: () => void;
}

const FilePickerActions: React.FC<FilePickerActionsProps> = (props: FilePickerActionsProps) => {
    const {
        hasFiles,
        disabled,
        canAddMore,
        onPick,
        onClearAll
    } = props;

    const pickDisabled = disabled || !canAddMore;

    return (
        <div className="flex justify-between items-center gap-3 flex-wrap mt-3">
            <AppButton
                onClick={onPick}
                disabled={pickDisabled}
                className={classNames(
                    "!bg-primary hover:!bg-[#005055] !border-0 !text-white !rounded-full !px-6 !py-3 transition-all duration-200",
                    pickDisabled ? "!opacity-40 cursor-not-allowed hover:!bg-primary" : ""
                )}
                classNameContentWrapper="!gap-2 !text-base !font-semibold"
            >
                <div className="!min-w-fit flex gap-2 items-center">
                    <span>{hasFiles ? "Dodaj kolejny plik" : "Wybierz pliki"}</span>
                    <AddDocumentIcon className="w-5 h-5"/>
                </div>
            </AppButton>

            {hasFiles && (
                <AppButton
                    onClick={onClearAll}
                    disabled={disabled}
                    className={classNames(
                        "text-sm font-semibold underline text-on-surface/70 transition-colors border-0",
                        disabled ? "cursor-not-allowed opacity-40" : "hover:text-on-surface"
                    )}
                >
                    Usuń wszystkie
                </AppButton>
            )}
        </div>
    );
};

export default FilePickerActions;
